<template>
  <header>
    <h1>
      <router-link to="/"> &#8962; </router-link>
    </h1>

    <ul>
      <li><router-link to="/members">Members</router-link></li>
      <li v-if="isLoggedIn">
        <router-link to="/groups">Groups</router-link>
      </li>
      <li v-else>
        <router-link to="/auth">Login</router-link>
      </li>
      <li v-if="isLoggedIn">
        <base-button @click="logout">Logout</base-button>
      </li>
    </ul>
  </header>
</template>


<script>

    export default {
       computed: {
         isLoggedIn() {
           return this.$store.getters.isAuthenticated;
         }
       },
       methods: {
         logout(){
           this.$store.dispatch('logOut');
           this.$router.replace('/home');
         }
       }
    }
</script>

<style scoped>
header {
  width: 100%;
  height: 5rem;
  background-color: cadetblue;
  display: flex;
  justify-content: center;
  align-items: center;
}

header a {
  text-decoration: none;
  color: white;
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border: 1px solid transparent;
}

a:active,
a:hover,
a.router-link-active {
  border: 1px solid white;
}

h1 {
  margin: 0;
}

h1 a {
  color: white;
  margin: 0;
}

h1 a:hover,
h1 a:active,
h1 a.router-link-active {
  border-color: transparent;
}

header nav {
  width: 90%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

header ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

li {
  margin: 0 0.5rem;
}
@media only screen and (max-width: 600px) {
  header {
    width: 100%;
    height: auto;
    background-color: cadetblue;

    /* justify-content: space-around; */
    /* align-items: center; */
    /* font-size: .58rem; */
    /* margin-bottom: 1rem; */
    /* padding-bottom: 1rem; */
  }

  li {
    margin: 0;
  }
}
</style>